import { Button, GridColumn } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<GridColumn
			scroll
			spacing={3}
			spacingAround={10}
		>
			<Button
				design="secondary"
				res="Back"
			/>
			<Button
				design="primary"
				res="Next"
			/>
			<Button
				design="link"
				res="Cancel"
			/>
		</GridColumn>
	);
};